export default {
  title: 'Canales de Marketing SMS',

  // Form related
  form: {
    phoneCode: 'Código de Teléfono',
    phoneCodePlaceholder: 'Ingresa código de teléfono',
    channelName: 'Nombre del Canal',
    channelNamePlaceholder: 'Ingresa nombre del canal',
    country: 'País',
    countryPlaceholder: 'Selecciona país',
    status: 'Estado',
    statusPlaceholder: 'Selecciona estado',
    currency: 'Moneda',
    currencyPlaceholder: 'Selecciona moneda',
    cost: 'Costo',
    costPlaceholder: 'Ingresa costo',
    remark: 'Observación',
    remarkPlaceholder: 'Ingresa observación'
  },

  // Table related
  table: {
    channelName: 'Nombre del Canal',
    country: 'País',
    cost: 'Costo',
    currency: 'Moneda',
    status: 'Estado',
    remark: 'Observación',
    actions: 'Acciones'
  },

  // Status related
  status: {
    enabled: 'Habilitado',
    disabled: 'Deshabilitado'
  },

  // Modal related
  modal: {
    editTitle: 'Editar Canal SMS'
  },

  // Validation related
  validation: {
    channelNameRequired: 'Por favor, ingresa nombre del canal',
    countryRequired: 'Por favor, selecciona país',
    phoneCodeRequired: 'Por favor, ingresa código de teléfono',
    currencyRequired: 'Por favor, selecciona moneda',
    costRequired: 'Por favor, ingresa costo',
    costMin: 'El costo no puede ser menor a 0',
    statusRequired: 'Por favor, selecciona estado'
  },

  // Message related
  message: {
    queryFailed: 'Consulta fallida',
    updateSuccess: 'Actualización exitosa',
    updateFailed: 'Fallo en la actualización',
    statusUpdateSuccess: 'Estado actualizado exitosamente',
    statusUpdateFailed: 'Fallo al actualizar estado'
  },

  // Confirm related
  confirm: {
    toggleStatus: '¿Estás seguro de que deseas cambiar el estado de este canal?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} registros'
  }
};
